<template>
  <div class="resistance-law-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>R = ρ · (L / S)$</div>
    </div>

    <div class="main-layout vertical">
      <!-- 混合仿真：导线模型 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 导线 -->
            <rect :x="200 - length/2" :y="110 - thickness/2" :width="length" :height="thickness" :fill="materialColor" stroke="#333" />
            
            <!-- 电流流动 (粒子) -->
            <circle v-for="i in 5" :key="i" 
              :cx="(200 - length/2) + ((t + i*40) % length)" 
              :cy="110 + (Math.sin(i)*thickness/3)" 
              r="2" fill="#00d2ff" />

            <!-- 尺寸标注 -->
            <line :x1="200 - length/2" y1="110 + thickness/2 + 10" :x2="200 + length/2" y2="110 + thickness/2 + 10" stroke="#888" stroke-dasharray="2,2" />
            <text :x="200" y="110 + thickness/2 + 25" text-anchor="middle" fill="#888" font-size="9">长度 L: {{ (length/10).toFixed(1) }} m</text>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>电阻 R</label>
               <span class="val">{{ currentR.toFixed(2) }} Ω</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <div class="col">
                  <label>长度 (L)</label>
                  <el-slider v-model="length" :min="50" :max="300" size="mini"></el-slider>
               </div>
               <div class="col">
                  <label>横截面积 (S)</label>
                  <el-slider v-model="thickness" :min="10" :max="60" size="mini"></el-slider>
               </div>
            </div>
            <div class="row">
               <div class="col-full">
                  <label>材料 (ρ):</label>
                  <el-radio-group v-model="rho" size="mini">
                     <el-radio-button :label="0.017">铜 (低电阻)</el-radio-button>
                     <el-radio-button :label="0.028">铝 (中电阻)</el-radio-button>
                     <el-radio-button :label="0.1">铁 (高电阻)</el-radio-button>
                  </el-radio-group>
               </div>
            </div>
         </div>

         <div class="law-box">
            <p><strong>电阻定律：</strong>同种材料在温度不变时，电阻与长度成<strong>正比</strong>，与横截面积成<strong>反比</strong>。ρ 是描述材料导电性能的电阻率。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResistanceLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      length: 150,
      thickness: 30,
      rho: 0.017,
      t: 0,
      running: true
    }
  },
  computed: {
    currentR() {
       return (this.rho * this.length) / (this.thickness * 0.1);
    },
    materialColor() {
       if (this.rho < 0.02) return '#e67e22'; // Copper
       if (this.rho < 0.05) return '#95a5a6'; // Aluminum
       return '#7f8c8d'; // Iron
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; },
  methods: {
    animate() {
       if (!this.running) return;
       this.t = (this.t + 2) % 300;
       requestAnimationFrame(this.animate);
    }
  }
}
</script>

<style scoped lang="scss">
.resistance-law-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; right: 15px; .val { color: #ffd700; font-family: monospace; } }
}
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row { margin-bottom: 8px; .col-full { label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } } } }
.law-box { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
